import React, { useMemo } from "react";
import { ProviderIcon } from "../../../shared/ProviderIcon";
import { PROVIDER_ORDER, toAnalyseProvider } from "../providerMap";
import { engineLabel, resolveWonBySummary } from "../strategyUtils";
import { InfoHint, SectionLabel } from "./shared";

export default function AiVisibilityCard({ strategy }) {
	const wonBy = useMemo(() => resolveWonBySummary(strategy), [strategy]);
	const providers = PROVIDER_ORDER.map((key) => {
		const found = strategy.providers.find(
			(p) => toAnalyseProvider(p.provider) === key
		);
		return { key, data: found };
	});

	return (
		<div className="monitoring__analysis-strategy-card monitoring__analysis-strategy-row-card monitoring__analysis-strategy-context-card">
			<div className="monitoring__analysis-strategy-card-head monitoring__analysis-strategy-card-head--with-badge">
				<div className="d-flex align-items-center gap-1">
					<SectionLabel>
						AI Visibility{" "}
						<span className="monitoring__analysis-strategy-context-subtitle">
							(Your Brand)
						</span>
					</SectionLabel>
					<InfoHint text="Whether each AI provider currently cites or mentions your brand when answering this prompt." />
				</div>
				{wonBy ? (
					<span className="monitoring__analysis-strategy-won-chip">
						Won by {wonBy.label}
						{wonBy.provider ? (
							<>
								{" "}
								(<ProviderIcon provider={wonBy.provider} size={12} />{" "}
								{engineLabel(wonBy.provider)})
							</>
						) : null}
					</span>
				) : null}
			</div>
			<div className="monitoring__analysis-strategy-card-body">
				<dl className="monitoring__analysis-strategy-meta mb-0">
					{providers.map(({ key, data }) => (
						<div key={key}>
							<dt className="monitoring__analysis-strategy-meta-provider">
								<ProviderIcon provider={key} size={14} />
								<span>{engineLabel(key)}</span>
							</dt>
							<dd>
								{data?.brand_mentioned ? (
									<span className="monitoring__analysis-strategy-mentioned">
										{data.target_brand_position
											? `#${data.target_brand_position} mention`
											: "Mentioned"}
									</span>
								) : (
									<span className="monitoring__analysis-strategy-not-mentioned">
										Not mentioned
									</span>
								)}
							</dd>
						</div>
					))}
				</dl>

				<div className="monitoring__analysis-strategy-context-section">
					<p className="monitoring__analysis-strategy-context-section-label mb-2">
						Provider Coverage
					</p>
					<p className="monitoring__analysis-strategy-coverage-count mb-1">
						{strategy.current_visibility.providers_mentioned} of{" "}
						{strategy.current_visibility.providers_total}{" "}
						<span className="monitoring__analysis-strategy-coverage-label">providers</span>
					</p>
					<p className="small text-muted mb-2">
						{strategy.current_visibility.providers_mentioned > 0
							? "Your brand is mentioned"
							: "Your brand isn't mentioned yet"}
					</p>
					<div className="monitoring__analysis-strategy-coverage-bar">
						<div
							className="monitoring__analysis-strategy-coverage-fill"
							style={{
								width: `${strategy.current_visibility.coverage_percentage}%`,
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
